import React from "react";
import m, { Moment } from "moment";
import { FormikHelpers, Field } from "formik";
import { Box, styled } from "@mui/material";

import { ICode } from "../types";
import { DATE_FORMAT } from "../../../../constants";
import { FormCheckbox, FormDatePicker, FormInput } from "../../index";
import { useAdminProviderDataContext } from "../../../../context";

interface IProps {
  values: ICode;
  setFieldValue: FormikHelpers<ICode>["setFieldValue"];
}

const FormDatePickerContainer = styled("div")({
  marginTop: 20,
  marginBottom: 10,
});

const DurationControls: React.FC<IProps> = ({ values, setFieldValue }) => {
  const { user } = useAdminProviderDataContext();

  return (
    <>
      <FormDatePickerContainer>
        <Field
          component={FormDatePicker}
          label="Expiry Date"
          name="expires"
          minDate={m()}
          datePickerProps={{ inputVariant: "standard" }}
          disabled={!values.autoExpires}
          onChange={(date: Moment | null) =>
            setFieldValue("expires", date ? date.format(DATE_FORMAT) : null)
          }
        />
      </FormDatePickerContainer>

      {user.allowed_features.set_code_expiration_props && (
        <Box px="5px" border="1px solid #e0e0e0" borderRadius={1}>
          {values.use_expiration_days && (
            <Field
              name="expiration_days"
              label="Expiration days"
              component={FormInput}
              variant="standard"
              type="number"
              step="1"
            />
          )}
          {!values.use_expiration_days && (
            <FormDatePickerContainer>
              <Field
                component={FormDatePicker}
                label="Expiration Date"
                name="expiration"
                minDate={m().add(30, "days")}
                datePickerProps={{ inputVariant: "standard" }}
                disabled={!values.use_expiration}
                onChange={(date: Moment | null) =>
                  setFieldValue("expiration", date ? date.format(DATE_FORMAT) : null)
                }
              />
            </FormDatePickerContainer>
          )}

          <Field
            name="use_expiration_days"
            label="Use expiration days"
            component={FormCheckbox}
            disabled={!values.use_expiration}
          />
        </Box>
      )}
      {(values.use_failover_type || values.use_failover_amt) && (
        <Field
          name="failover_amt"
          component={FormInput}
          label="Discount amount past expiration"
          type="number"
          variant="standard"
          step="1"
        />
      )}
    </>
  );
};

export default DurationControls;
